import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

// Classic layout - similar to the current layout
const ClassicLayout = ({ children = null, sections = [] }) => {
  // Organize sections by their type
  const sectionsByType = sections.reduce((acc, section) => {
    if (!acc[section.type]) {
      acc[section.type] = [];
    }
    acc[section.type].push(section.component);
    return acc;
  }, {});

  return (
    <Box sx={{ width: '100%' }}>
      {/* Hero section at the top */}
      {sectionsByType.hero && sectionsByType.hero.map((Component, index) => (
        <Box key={`hero-${index}`} sx={{ width: '100%' }}>
          <Component />
        </Box>
      ))}
      
      {/* Featured properties */}
      {sectionsByType.featured && sectionsByType.featured.map((Component, index) => (
        <Box key={`featured-${index}`} sx={{ width: '100%', my: 4 }}>
          <Component />
        </Box>
      ))}
      
      {/* Services section - перемещено сюда, чтобы шло сразу после объектов */}
      {sectionsByType.services && sectionsByType.services.map((Component, index) => (
        <Box key={`services-${index}`} sx={{ width: '100%', my: 4 }}>
          <Component />
        </Box>
      ))}
      
      {/* Tips section - полезные советы перед блогом */}
      {sectionsByType.tips && sectionsByType.tips.map((Component, index) => (
        <Box key={`tips-${index}`} sx={{ width: '100%', my: 4 }}>
          <Component />
        </Box>
      ))}
      
      {/* Recent Blog Posts section */}
      {sectionsByType.recentPosts && sectionsByType.recentPosts.map((Component, index) => (
        <Box key={`recentPosts-${index}`} sx={{ width: '100%', my: 4 }}>
          <Component />
        </Box>
      ))}
      
      {/* About section */}
      {sectionsByType.about && sectionsByType.about.map((Component, index) => (
        <Box key={`about-${index}`} sx={{ width: '100%', my: 4 }}>
          <Component />
        </Box>
      ))}
      
      
      {/* Testimonials section */}
      {sectionsByType.testimonials && sectionsByType.testimonials.map((Component, index) => (
        <Box key={`testimonials-${index}`} sx={{ width: '100%', my: 4 }}>
          <Component />
        </Box>
      ))}
      
      {/* Any additional sections */}
      {sectionsByType.additional && sectionsByType.additional.map((Component, index) => (
        <Box key={`additional-${index}`} sx={{ width: '100%', my: 4 }}>
          <Component />
        </Box>
      ))}
      
      {/* Any custom children */}
      {children}
    </Box>
  );
};

ClassicLayout.propTypes = {
  children: PropTypes.node,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      component: PropTypes.elementType.isRequired
    })
  ).isRequired
};

// Удаляем defaultProps и используем параметры по умолчанию в сигнатуре функции выше

export default ClassicLayout;
